import type { Admin } from '#dn-types/admin.ts';
import type { ResourceListOptions } from '#dn-types/api.ts';
import { rewordValidationMessages } from './errors.ts';
import { del, getList, post } from './fetch.ts';

export const DEFAULT_ADMINS_PAGE_SIZE = 25;

// POST /users
export type AddAdminVariables = {
  email: string;
};
export type AddAdminResult = Admin;
export function addAdmin(formData: AddAdminVariables) {
  return (
    post<Admin>('/v1/users', formData)
      // Convert from server error codes to more friendly strings, if possible
      .catch((err: unknown) => {
        rewordValidationMessages(err, (details) => {
          if (details.path === 'email' && details.code === 'ERR_DUPLICATE_VALUE') {
            return 'An email may only be an admin for one account.';
          }
          if (details.path === 'email' && details.code === 'ERR_INVALID_EMAIL') {
            return 'Please enter a valid email address.';
          }
          if (details.path === undefined && details.code === 'ERR_LIMIT_EXCEEDED') {
            return 'You have reached the maximum number of admins for this organization.';
          }
        });
      })
  );
}

// GET /users
export type GetAdminsResult = Admin[];
export function getAdmins({ cursor = '', pageSize = DEFAULT_ADMINS_PAGE_SIZE, init }: ResourceListOptions = {}) {
  return getList<GetAdminsResult>(`/v1/users?cursor=${encodeURIComponent(cursor)}&pageSize=${pageSize}`, init);
}

// DELETE /users/:id
export type DeleteAdminResult = Record<string, never>;
export function deleteAdmin(id: string, init?: RequestInit) {
  return del<DeleteAdminResult>(`/v1/users/${encodeURIComponent(id)}`, init);
}
